import { combineReducers } from "redux";
import loginPage from "./loginPage";
import notification from "./notification";
import titleList from "./titleList";
import appTitles from "./appTitles";
import appIssues from "./appIssues";
import issueList from "./issueList";
import articleList from "./articleList";
import appIssueProdData from "./appIssueProdData";
import issueMediaUploader from "./issueMediaUploader";
import copyModal from "./copyModal";
import tocEditPanel from "./tocEditPanel";
import pdfEditTocContainer from "./pdfEditTocContainer";
import editArticlePanel from "./editArticlePanel";
import pdfEditArticleAVList from "./pdfEditArticleAVList";
import singlePdfPageContainer from "./singlePdfPageContainer";

export default combineReducers({
  loginPage,
  notification,
  titleList,
  appTitles,
  appIssues,
  issueList,
  articleList,
  appIssueProdData,
  issueMediaUploader,
  copyModal,
  tocEditPanel,
  pdfEditTocContainer,
  editArticlePanel,
  pdfEditArticleAVList,
  singlePdfPageContainer
});
